import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { relevant } from '../../api';
import classes from '../../api/classes';
import TextField from '../../components/TextField';
import PopupSelector from '../../components/PopupSelector';
import { Button } from '../../components/Button/Button';
import { FormOf } from '../../components/Wrappers';
import BrowserUtils from '../../lib/browserUtils';
const { SlackIntegration } = classes;

interface SlackIntegrationEditProps {
	history: any;
	backUrl: string;
	onChange?: () => void;
}

interface SlackState {
	enabled: boolean;
	hasUpdate: boolean;
}

const downloadManifest = async () => {
	const json = await SlackIntegration.callStatic('getManifest');
	BrowserUtils.downloadJSONFile(json, 'slack_manifest.json');
};

export function SlackIntegrationEdit({ history, backUrl, onChange }: SlackIntegrationEditProps) {
	const goBack = () => backUrl && history.push(backUrl);
	const [slackState, setSlackState] = useState<SlackState>({});
	const [isUpdating, setIsUpdating] = useState(false);

	useEffect(() => {
		(async () => {
			const state = await SlackIntegration.callStatic('getIntegrationState');
			setSlackState(state);
		})();
	}, []);

	return (
		<FormOf
			model={{ clientId: '', clientSecret: '', signingSecret: '' }}
			content={(fd) => {
				return (
					<PopupSelector
						title="Slack Integration"
						size="md"
						forceExpanded
						allowErrorsIfCancel
						okLabel="SAVE"
						onApplyChanges={async () => {
							if (!fd.form.hasErrors()) {
								await SlackIntegration.callStatic('setIntegrationData', fd.model);
								if (onChange) {
									onChange();
								}
								goBack();
							}
						}}
						onCancel={goBack}
						content={() => (
							<Grid container spacing={3} direction="column">
								<Grid item xs={4}>
									<Button
										onClick={() => window.open(`${relevant.baseUrl}slack/create`, '_blank')}
									>
										{slackState.enabled ? 'Reinstall' : 'Install'} Slack app to your workspace
									</Button>
								</Grid>
								<Grid item xs={4}>
									<TextField
										{...fd.field('clientId')}
										label="Client ID"
										required
										fullWidth
									/>
								</Grid>
								<Grid item xs={4}>
									<TextField
										{...fd.field('clientSecret')}
										label="Client Secret"
										required
										fullWidth
									/>
								</Grid>
								<Grid item xs={4}>
									<TextField
										{...fd.field('signingSecret')}
										label="Signing Secret"
										required
										fullWidth
									/>
								</Grid>
								{slackState.hasUpdate && (
									<Grid item xs={4}>
										<Button
											onClick={() => {
												if (isUpdating) {
													setSlackState({ ...slackState, hasUpdate: false });
													SlackIntegration.callStatic('completeUpdate');
												} else {
													setIsUpdating(true);
													downloadManifest();
												}
											}}
										>
											{isUpdating ? 'Mark update complete' : 'Download latest manifest (to update existing apps)'}
										</Button>
									</Grid>
								)}
							</Grid>
						)}
					/>
				);
			}}
		/>
	);
}
